var _rect, _text, _text2, _circle, _path, _rect2, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMayaraRestaurant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 60,
    rx: 8,
    fill: "#EF4444"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 25,
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "MAYARA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 40,
    fontFamily: "Arial, sans-serif",
    fontSize: 7,
    textAnchor: "middle",
    fill: "white"
  }, "RESTAURANT")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 30,
    r: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 30 L20 27 L23 30 L20 33 Z",
    fill: "#EF4444"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 25,
    width: 8,
    height: 10,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 22,
    r: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMayaraRestaurant);
export default __webpack_public_path__ + "static/media/mayara-restaurant.e40ed50e0a857428fce55a679ad73f62.svg";
export { ForwardRef as ReactComponent };